import React, { Component } from 'react'
import Div100vh from "react-div-100vh";
import PersonalHubPage from '../../components/personalHub/PersonalHubPage'


class PersonalHub extends Component {
    render() {
        return (
            <div style={{ overflowY: "auto" }}>
                <Div100vh>
                    <PersonalHubPage/>
                </Div100vh>
            </div>
        )
    }
}

export default PersonalHub
